// * Bootstrap libraries
import "./_bootstrap";

// * Any other global site-wide JavaScript should be placed below.

(function ($, Drupal, once) {
  Drupal.behaviors.cfa = {
    attach: function (context, settings) {

      once('menu-toggle', '#toggle-main-aside-menu').forEach(function (element) {
        var toggle = document.querySelector('#toggle-main-aside-menu');
        var menu = document.querySelector('#main-aside-menu');

        if (toggle) {
          toggle.addEventListener('click', function () {
            if (menu.classList.contains('is-active')) {
              this.setAttribute('aria-expanded', 'false');
              menu.classList.remove('is-active');
            } else {
              menu.classList.add('is-active');
              this.setAttribute('aria-expanded', 'true');
            }
          });

        }
      });


      once('sidebar-menu', '#main-aside-menu .btn-link', context).forEach(function (element) {
        $(element).on('click', function () {
          $(this).parent().toggleClass('menu-item--expanded')
          const expanded = $(this).attr('aria-expanded')
          if (expanded === 'true') {
            $(this).attr('aria-expanded', 'false')
          } else {
            $(this).attr('aria-expanded', 'true')
          }
        })
      });

      once('lazy-video', '.lazy-load-media__img', context).forEach(function (element) {
        $(element).on('click', function () {
          const $container = $(this).closest('.lazy-load-media').find('.lazy-container');
          const $iframe = $container.find('iframe');
          const src = $iframe.data('src');

          if (src) {
            $iframe.attr('src', src).show();
            $container.show();
            $(this).hide();
          }
        })
      });
    }
  };
})(jQuery, Drupal, once);
